export default {
    methods: {
        resolveInnerTags(tagName) {
            var items = []
            for (const childSlot of this.$slots.default) {
                if ((childSlot.tag && childSlot.tag.indexOf(tagName) !== -1)) {
                    var childOptions = childSlot.componentOptions
                    var item = childOptions.propsData

                    if (!childOptions.propsData.items) {
                        item.items = childSlot.componentInstance.subitems
                    }

                    items.push(item)
                    this.handleWatcher(childSlot.componentInstance)
                }
            }

            return items
        },
        handleWatcher(childInstance) {
            var that = this

            if(!childInstance._isWatchAttached){
                childInstance.$watch('$props', () => {
                    if(that.updateWidget){
                        that.updateWidget()
                    } else if (that._resolveInnerChildren) {
                        that._resolveInnerChildren()
                    }
                }, { deep: true })

                childInstance._isWatchAttached = true
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-base-components-vue-wrapper/src/kendo-shared-methods/index.js